<template>
  <div
    class="cover-voice-custom-upload"
    :class="{
      [`cover-voice-custom-upload--${createRenderType}`]: true,
    }"
  >
    <file-pond
      ref="refUpload"
      v-if="renderData.ifRenderFilePond"
      label-idle="歌曲文件"
      v-bind:allow-multiple="true"
      :acceptedFileTypes="renderData.acceptedFileTypes.join(',')"
      @addfile="handleAddFile"
      v-bind:files="renderData.files"
    >
    </file-pond>
    <div
      class="cover-voice-custom-upload-content"
      @click.stop
      ref="refUploadContent"
    >
      <div class="cover-voice-custom-upload-box">
        <div class="cover-voice-custom-upload-add flex">
          <i class="block"></i>
          <span class="block description">
            {{ $$t("editor.voice_dataset_upload_description") }}
          </span>
          <span class="block add-file pointer" @click="onAddFileButtonClick">{{
            $$t("editor.upload_files")
          }}</span>
        </div>

        <div class="cover-voice-custom-upload-description">
          <p>
            <span>{{ $$t("editor.voice_dataset_label_duration") }}</span>
            {{ $$t("editor.voice_dataset_description_duration") }}
          </p>
          <p>
            <span>{{ $$t("editor.voice_dataset_label_quality") }}</span>
            {{ $$t("editor.voice_dataset_description_quality") }}
          </p>
          <p>
            <span>{{ $$t("editor.voice_dataset_format_label") }}</span>
            {{ $$t("editor.voice_dataset_description_format") }}
          </p>
        </div>

        <div class="cover-voice-custom-upload-add-mobile">
          <Button
            @click="onAddFileButtonClick"
            :disabled="props.disabled"
            :loading="props.isLoading"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '44px',
              '--borderRadius': '40px',
              '--background': 'rgba(255, 255, 255, 0.2)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': '500',
              '--border': 'none',
              '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
              '--fontColorHover': '#fff',
            }"
          >
            <div class="cover-voice-custom-upload-add-mobile-btn flex">
              <i class="block"></i>
              <span calss="block">{{ $$t("editor.upload_files") }}</span>
            </div>
          </Button>
        </div>
      </div>

      <div
        class="cover-voice-custom-upload-files"
        v-if="renderData.files?.length"
      >
        <div class="add-file fn-inline pointer">
          <i class="block"></i>
        </div>

        <div class="file-item fn-inline">
          <i class="block file-ico"></i>
          <div class="file-item-name-op flex">
            <span class="file-item-name olh">file name</span>
            <i class="block"></i>
          </div>
        </div>

        <div class="file-item fn-inline">
          <i class="block file-ico"></i>
          <div class="file-item-name-op flex">
            <span class="file-item-name olh">file name</span>
            <i class="block"></i>
          </div>
        </div>
        <div class="file-item fn-inline">
          <i class="block file-ico"></i>
          <div class="file-item-name-op flex">
            <span class="file-item-name olh">file name</span>
            <i class="block"></i>
          </div>
        </div>
      </div>

      <div class="cover-voice-custom-upload-devider flex">
        <i class="block line line-left"></i>
        <span>{{ $$t("editor.or") }}</span>
        <i class="block line line-right"></i>
      </div>

      <div class="cover-voice-custom-upload-youtube" @click.stop>
        <input
          :placeholder="$$t('editor.paste_youtube_link')"
          v-model="renderData.youtubeLink"
        />
        <Button
          @click="doAddReferenceLinkDone"
          :disabled="props.disabled"
          :loading="props.isLoading"
          :renderStyle="{
            '--padding': '0',
            '--width': '137px',
            '--height': '40px',
            '--borderRadius': '40px',
            '--background': 'rgba(148, 173, 255, 1)',
            '--fontColor': '#000',
            '--fontSize': '14px',
            '--fontWeight': '500',
            '--border': 'none',
            '--backgroundHover': 'rgba(148, 173, 255, 0.75)',
            '--fontColorHover': '#000',
          }"
        >
          <span class="fn-inline">{{ $$t("store.upload") }}</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";

import { $$language, $$t, $$tValue } from "@/i18n/i18n.js";
import tools from "@/utils/tools.js";
import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js";
import message from "@/components/functionCallComponent/message.jsx";
import clipUtil from "@/components/media/utils/clipUtil.js";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";

import apiCommon from "@/api/api/apiCommon.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import useCoverVoiceCustomSingerDataStore from "@/store/editor/coverVoiceCustomSingerDataStore.js";
const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const coverVoiceCustomSingerDataStore = useCoverVoiceCustomSingerDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);

import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

const FilePond = vueFilePond();

const Router = useRouter();
const route = useRoute();

const refUpload = ref(null);
const refUploadContent = ref(null);

const props = defineProps({});
const emits = defineEmits([]);
const acceptedFileTypes = [
  "audio/x-wav",
  "video/quicktime",
  "video/mp4",
  "audio/wav",
  "audio/x-m4a",
  "audio/flac",
  "audio/mpeg",
  ".mp3",
  ".wav",
  ".m4a",
  ".mp4",
  ".mov",
  ".MP4",
  ".flac",
];
const renderData = reactive({
  ifRenderFilePond: true,
  files: [],
  file: null,
  acceptedFileTypes: acceptedFileTypes,
  editFilePopupVisible: false,
  youtubeLink: "",
});

const checkMediaType = (file) => {
  if (file.type.toLocaleLowerCase().startsWith("audio")) {
    return acceptedFileTypes.includes(file.type.toLocaleLowerCase())
      ? "audio"
      : "unknown";
  } else if (file.type.toLocaleLowerCase().startsWith("video")) {
    return acceptedFileTypes.includes(file.type.toLocaleLowerCase())
      ? "video"
      : "unknown";
  } else {
    return "unknown";
  }
};

const initUploadContent = () => {
  if (refUploadContent.value) {
    nextTick(() => {
      refUpload.value?.$el
        .querySelector(".filepond--drop-label")
        .appendChild(refUploadContent.value);
    });
    setTimeout(() => {
      refUpload.value?.$el
        ?.querySelector("input")
        ?.setAttribute("accept", renderData.acceptedFileTypes.join(","));
    }, 20);
  }
};

const onAddFileButtonClick = () => {
  refUpload.value?.$el.querySelector(".filepond--drop-label").dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );
};

const handleAddFile = (error, fileItem, fileList) => {
  return;
  if (error) {
    console.error("File add error:", error);
    return;
  }
  if (!file || !file instanceof File) {
    reject("not file");
    return;
  }
  let fileType = checkMediaType(file);
  if (fileType == "unknown") {
    reject("not audio");
    return;
  }
  if (file.size > 1024 * 1024 * 100) {
    reject("max file size");
    return;
  }
  console.log("File added:", fileItem);
};

const handleAfterRead = (file) => {
  return new Promise(async (resolve, reject) => {
    try {
      const duration = await tools.getMediaFileDuration(file);
      if (duration > 0) {
        if (duration < 15) {
          reject("min file duration");
        } else if (duration > 4 * 60 + 30) {
          reject("max file duration");
        } else {
          resolve(file);
        }
      } else {
        reject("not audio");
        return;
      }
    } catch (e) {
      try {
        const outputfile = await ffmpegUtil.transFileToMp3(file);
        let duration = 0;
        if (outputfile) {
          duration = await tools.getMediaFileDuration(outputfile.file);
        }
        if (duration > 0) {
          if (duration < 15) {
            reject("min file duration");
          } else if (duration > 4 * 60 + 30) {
            reject("max file duration");
          } else {
            resolve({
              file: outputfile.file,
              name: outputfile.file.name,
              type: outputfile.file.type,
              size: outputfile.file.size,
              duration: duration,
            });
          }
        } else {
          reject("not audio");
          return;
        }
      } catch (e) {
        reject("not audio");
      }
    }
  });
};

const doSaveLink = async () => {
  return new Promise((resolve, reject) => {
    if (
      !validateYoutubeLink(renderData.linkUrl)
    ) {
      message.error({
        position: "top",
        content: $$t("create.use_youtube"),
      });
      reject("invalid youtube link");
      return;
    }
    const params = {
      url: renderData.youtubeLink,
    };
    renderData.isLoading = true;
    const closeMsg = message.loading({ content: $$t("create.parsing_link") });
    apiCommon
      .saveReferenceMusicTmp({
        url: renderData.youtubeLink,
        min_duration_milliseconds: 15 * 1000,
        max_duration_milliseconds: (4 * 60 + 30) * 1000,
      })
      .then((res) => {
        closeMsg?.clear();
        if (res.code == 200) {
          resolve(res.data);
        } else {
          if (
            res.code == 6116 ||
            (res.data?.duration_milliseconds ?? res.data?.duration ?? 0) ==
              7 * 1000 * 60
          ) {
            renderData.youtubeLink = "";
            message.error({
              position: "top",
              content: $$t("create.style_link_max_duration"),
            });
          } else if (res.code == 1112) {
            message.error({
              position: "top",
              content: $$t("create.cur_position"),
            });
          } else {
            message.error({
              position: "top",
              content: $$t("create.invalid_link"),
            });
          }
          reject("invalid spider link");
        }
      })
      .catch((e) => {
        closeMsg?.clear();
        message.error({
          position: "top",
          content: $$t("create.invalid_link"),
        });
        reject(e);
      });
  });
};

const doAddReferenceLinkDone = () => {
  doSaveLink()
    .then((data) => {})
    .catch((e) => {
      console.error("doSaveLink error", e);
    });
};

const doUploadFile = async (file) => {
  if (
    !(
      clipUtil.isMP3ByMimeType(file.type) ||
      clipUtil.isMP3ByExtension(file.name)
    )
  ) {
    try {
      const outputfile = await ffmpegUtil.transFileToMp3(file);
      file = outputfile.file;
    } catch (e) {
      console.error("ffmpegUtil.transFileToMp3 error", e);
    }
  }
  const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
    renderData.file,
    (obj) => {
      renderData.uploadCallbackData = obj;
    }
  );
  const saveData = {
    title: renderData.file.name?.replace(/.[a-zA-Z0-9]+$/, ""),
    cos_url: objectStorageRes.pathKey,
  };
};

onMounted(() => {
  nextTick(() => {
    initUploadContent();
  });
});
</script>
<style lang="scss">
.cover-voice-custom-upload {
  --filepond-min-height: 256px;
  --filepond-border-radius: 8px;
  .cover-voice-custom-upload-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    height: 100%;
  }

  .cover-voice-custom-upload-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    width: 100%;
  }
  .cover-voice-custom-upload-add {
    align-items: center;
    justify-content: center;
    width: 100%;
    i {
      height: 24px;
      width: 24px;
      background: url("@/assets/img/editor/audio-file-ico.png");
      background-size: 100% 100%;
    }
    .description {
      font-family: HarmonyOS Sans SC;
      font-size: 18px;
      font-weight: bold;
      line-height: 24px;
      color: #ffffff;
      margin: 0 8px;
    }
    .add-file {
      font-family: HarmonyOS Sans SC;
      font-size: 18px;
      font-weight: bold;
      line-height: 24px;
      color: #ffe95e;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .cover-voice-custom-upload-description {
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    color: #ffffff;
    margin: 8px 0 0 0;
    span {
      display: inline-block;
      font-weight: 700;
      font-size: 14px;
      margin: 0 4px 0 0;
      padding: 0;
    }
  }

  .cover-voice-custom-upload-files {
    height: 136px;
    width: 100%;
    overflow-y: auto;
    .add-file {
      height: 56px;
      width: 56px;
      border-radius: 4px;
      background: rgba(148, 173, 255, 0.3);
      padding: 22px;
      i {
        height: 12px;
        width: 12px;
        background: url("@/assets/img/editor/singer-add.png");
        background-size: 100% 100%;
      }
      &:hover {
        background: rgba(148, 173, 255, 0.5);
      }
    }
    .file-item {
      margin: 0 0 0 16px;
      .file-ico {
        width: 32px;
        height: 32px;
        background: url("@/assets/img/editor/audio-file-ico.png");
        background-size: 100% 100%;
        margin: 0 auto;
      }
      .file-item-name-op {
        align-items: center;
        margin: 14px 0 0 0;
        span {
          font-family: HarmonyOS Sans SC;
          font-size: 12px;
          font-weight: normal;
          line-height: 12px;
          color: #ffffff;
          flex: 0 1 auto;
        }
        i {
          width: 12px;
          height: 12px;
          min-width: 12px;
          margin: 0 0 0 2px;
          background: url("@/assets/img/editor/delete-ico.png");
          background-size: 100% 100%;
        }
      }
    }
  }
  .cover-voice-custom-upload-devider {
    margin: 12px 0;
    align-items: center;
    i {
      width: 200px;
      height: 1px;
    }
    .line-left {
      background: linear-gradient(
        270deg,
        #d8d8d8 0%,
        rgba(216, 216, 216, 0) 99%
      );
    }
    .line-right {
      background: linear-gradient(
        90deg,
        #d8d8d8 0%,
        rgba(216, 216, 216, 0) 99%
      );
    }

    span {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 16px;
      color: #ffffff;
      margin: 0 12px;
    }
  }
  .cover-voice-custom-upload-youtube {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    border-radius: 60px;
    background: rgba(255, 255, 255, 0.1);

    input {
      width: 0;
      flex: 1;
      padding: 0 12px 0 20px;
      height: 40px;
      background: none;
      border: none;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 18px;
      color: #ffffff;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
  }
  .cover-voice-custom-upload-add-mobile {
    display: none;
  }
  .filepond--root {
    height: max-content !important;
    min-height: var(--filepond-min-height) !important;
    background: transparent;
    box-shadow: none;
    align-items: center;
    justify-content: center;
    border-radius: var(--filepond-border-radius);
    margin: 0;
    contain: unset !important;
    line-height: 0;
    .filepond--wrapper {
      height: max-content !important;
      border-radius: var(--filepond-border-radius);
    }
    .filepond--browser.filepond--browser {
      display: none;
    }
    .filepond--list-scroller {
      display: none;
    }
    .filepond--credits {
      display: none;
    }

    .filepond--panel-root {
      border-radius: 0.5em;
      background: transparent;
      box-shadow: none;
      border-radius: max-content;
      display: none;
    }

    .filepond--assistant {
      display: none;
    }
    .filepond--drop-label {
      display: block;
      position: unset !important;
      visibility: visible !important;
      transform: translate3d(0px, 0, 0px) !important;
      height: max-content !important;
      border-radius: var(--filepond-border-radius) !important;
      min-height: var(--filepond-min-height) !important;
      opacity: 1 !important;
      pointer-events: auto !important;
      & > label {
        display: none;
      }
    }
    .filepond--data {
      display: none;
    }
    &[data-hopper-state="drag-over"] {
      .cover-voice-custom-upload-content {
        border: 1px dashed #94adff;
        padding: 19px;
      }
    }
  }

  &.cover-voice-custom-upload--mobile {
    .cover-voice-custom-upload-content {
      padding: 14px;
    }
    .cover-voice-custom-upload-add {
      display: none;
    }
    .cover-voice-custom-upload-box {
      padding: 0;
    }
    .cover-voice-custom-upload-description {
      margin: 0 0 8px 0;
    }
    .cover-voice-custom-upload-devider {
      .line {
        width: 100px;
      }
    }
    .cover-voice-custom-upload-add-mobile {
      width: 100%;
      display: block;
      .cover-voice-custom-upload-add-mobile-btn {
        align-items: center;
        height: 100%;
        i {
          height: 20px;
          width: 20px;
          margin: 0 6px 0 0;
          background: url(@/assets/img/upload-white-ico.png);
          background-size: 100% 100%;
        }
      }
    }
    .filepond--root {
      &[data-hopper-state="drag-over"] {
        .cover-voice-custom-upload-content {
          border: 1px dashed #94adff;
          padding: 13px;
        }
      }
    }
  }
}
</style>
